import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import SummaryItem from '../../Organisms/SummaryItem'
import CardHelp from '../../Molecules/CardHelp'
import PageHeader from '../../Molecules/PageHeader'

import theme from '../../../styles/theme'

const Container = styled(View)`
  flex: 1;
  flex-direction: column;
`

const CardContainer = styled(View)`
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0 ${theme.gutterUnit}px;
`

const SummaryItemContainer = styled(View)`
  width: ${({ numberOfTiles }) => 100 / numberOfTiles}%;
  height: 50%;
  padding: ${theme.gutterUnit}px;
`

export default class Summary extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      cardHelp: {
        isVisible: false,
        styles: {
          left: 0,
          top: 0
        },
        heading: '',
        body: ''
      },
      dimensions: null
    }
  }

  handleLayout = event => {
    if (this.state.dimensions) return // layout was already called

    const { width, height } = event.nativeEvent.layout
    this.setState({
      dimensions: { width, height }
    })
  }

  handlePressHelp = (evt, heading, body) => {
    if (heading !== this.state.cardHelp.heading && this.state.dimensions) {
      const { width, height } = this.state.dimensions

      this.setState({
        cardHelp: {
          isVisible: true,
          styles: {
            left: (width / 2) - 250,
            top: (height / 2) - 250
          },
          heading,
          body
        }
      })
    }
  }

  handlePressCloseHelp = () => {
    this.setState({
      cardHelp: {
        isVisible: false,
        styles: {
          left: 0,
          top: 0
        },
        heading: '',
        body: ''
      }
    })
  }

  render () {
    return (
      <Container>
        <PageHeader />
        <CardContainer onLayout={this.handleLayout} style={{ opacity: 1 }}>
          <CardHelp border cardHelp={this.state.cardHelp} onCloseHandler={this.handlePressCloseHelp} />
          {this.props.items.map((item, index) => {
            return (
              <SummaryItemContainer key={item.type} numberOfTiles={this.props.maxPerPage / 2}>
                <SummaryItem item={item} index={index} onPressHelpHandler={this.handlePressHelp} />
              </SummaryItemContainer>
            )
          })}
        </CardContainer>
      </Container>
    )
  }
}
